export default "<app-category-multi-list [racine]=\"'item'\" canEdit=\"true\" [showSubCategory]=\"true\"></app-category-multi-list>"